// ==========================================
// API Configuration
// ==========================================
/**
 * Get the API base URL from environment variable or return default
 * @returns {string} - API base URL
 */
export const server_api = () => {
  // Empty string = same-origin relative URLs (dev/UAT via Apache+CRA proxy).
  return process.env.REACT_APP_API_BASE_URL ?? 'https://api.prod.webdekho.in:8085';
};

/**
 * Set the API base URL in localStorage
 * @param {string} url - The base URL to save
 */
export const setBaseUrl = (url) => {
  console.log('Ignoring custom API host override. Using current host only:', url);
};

/**
 * Clear the saved base URL from localStorage
 */
export const clearBaseUrl = () => {
  localStorage.removeItem('host');
  console.log('Custom API host override cleared');
};

/**
 * Get current base URL (use this for API calls)
 */
export const API_BASE_URL = server_api();

// ==========================================
// App Configuration
// ==========================================
export const APP_VERSION = 7;
export const PLATFORM = "web";

// ==========================================
// Customer App URL — derived from current admin host so multi-restaurant
// deployments (admin.{tenant}.com → {tenant}.com) Just Work without per-env
// config. Override with REACT_APP_CUSTOMER_BASE_URL when admin and customer
// live on unrelated domains.
// ==========================================
export const customerAppBaseUrl = () => {
  const override = process.env.REACT_APP_CUSTOMER_BASE_URL;
  if (override) return override.replace(/\/+$/, '');
  if (typeof window === 'undefined') return '';
  const { protocol, hostname, port } = window.location;
  // Strip a leading "admin." (or "admin-") subdomain. Localhost / IPs / bare
  // hostnames pass through unchanged so dev mode stays usable.
  let host = hostname;
  const adminPrefix = /^admin[.-]/i;
  if (adminPrefix.test(host)) {
    host = host.replace(adminPrefix, '');
  }
  const portPart = port && port !== '80' && port !== '443' ? `:${port}` : '';
  return `${protocol}//${host}${portPart}`;
};

// ==========================================
// Firebase Configuration
// ==========================================
// Get your VAPID key from Firebase Console:
// Project Settings > Cloud Messaging > Web Push certificates > Generate key pair
export const FIREBASE_VAPID_KEY = "BLx1gw_uBrpoOJGgcDkRWsVcWZlK8dcH3FqYmSfQnfEQxEZmnC68BfiooUryHu_iSWo2T4_ALvScQSVfCxu1lIM";
